<template>
  <div id="v-simple-card">
    <v-card>
      <v-toolbar color="transparent" flat dense card>
        <v-toolbar-title>
          <h4>
            <v-icon v-if="icon">{{ icon }}</v-icon>
            {{ title }}
          </h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="widget-header-action"></slot>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text :class="contentBackground" :style="textCardStyle">
        <slot></slot>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "v-simple-card",
  props: {
    title: {
      type: String
    },
    contentBackground: {
      type: String,
      default: "white"
    },
    icon: {
      type: String,
      default: null
    },
    textCardStyle: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {}
};
</script>
